module.exports = __webpack_public_path__ + "Lato-LightItalic.3d747d8bf464744eecb9";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-LightItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-LightItalic.ttf
// module chunks = styles